export const productColumns = [
  { key: 'code', text: 'Code', width: '5%' },
  { key: 'name', text: 'Name', width: '20%' },
  { key: 'interest', text: 'Interest Rate', width: '10%' },
  { key: 'terms', text: 'Terms (Days)', width: '10%' },
  { key: 'options', text: '', width: '5%' }
];
